/**
 * drl_back_to_top_button JS
 */

import $ from 'jquery';

Drupal.behaviors.drl_back_to_top_button = {
  attach() {
    $(function backToTop() {
      $('ul li ul .menu-item--expanded').on('click', function addClass(e) {
        /* Upon multiple dropdown in single parent, click on one single element fix.
        Current implementation had a bug where both child menu item was opening at a time.
        */
        if ($('.menu-item--expanded').hasClass('menu-active')) {
          $('.menu-item--expanded').removeClass('menu-active');
        }
        $(this).toggleClass('menu-active');
        e.stopPropagation();
      });
      $(document).on('click', function removeClass(e) {
        if ($('.menu-item--expanded').hasClass('menu-active')) {
          $('.menu-item--expanded').removeClass('menu-active');
        }
        if ($(e.target).is('.menu-item--expanded') === false) {
          $(this).removeClass('menu-active');
        }
      });
    });
  },
};
